import bookIcon from 'assets/icons/book.svg';
import { Img } from 'shared/ui/imgStyledComponent';

export const BookIcon = () => {
	return <Img role="image" src={bookIcon} />;
};
